import { useStore } from 'store';

export const useGenerateTopBorder = () => {
  const top_border = useStore((state) => state.params.top_border);

  return {
    visibleTopBorder: top_border,
  };
};
